import { BaseMetaColumn } from "./BaseMetaColumn";
import { BaseMetaTable } from "./BaseMetaTable";
import { EncodingOperation } from "./EncodingOperation";
import { ErrorOperation } from "./ErrorOperation";
import { FilterItemOperator } from "./FilterItemOperator";

export class FilterItem
{
    public table: BaseMetaTable;
    public column: BaseMetaColumn;
    public not: boolean;
    public operator: FilterItemOperator;
    public values: string[];
    public static encode(filters: FilterItem[] | null): string
    {
        let value = this.stringify(filters);
        return EncodingOperation.Base64Encode(value);
    }
    public static decode(value: string): FilterItem[] | null
    {
        let encoded = EncodingOperation.Base64Decode(value);
        return this.parse(encoded);
    }
    public static stringify(filters: FilterItem[] | null): string
    {
        if (filters)
            return filters.map(x => x.getCommand()).join(";");
        return "";
    }
    public static parse(item: string | null): FilterItem[]
    {
        let ans: FilterItem[] = [];
        if (item)
        {
            let index = 0;
            let items = item.split(/(?<!\\);/);
            let thereIsMore = (): boolean =>
            {
                return index < items.length;
            };
            let next = (name: string): string =>
            {
                if (thereIsMore())
                    return items[index++];
                throw ErrorOperation.getHTTP(400, `Next value is required for '${name}'. Must be separated by ;`);
            };
            while (thereIsMore())
            {
                let value_table = next("Table");
                let table = new BaseMetaTable(null, value_table, value_table);

                let value_column = next("Column");
                let column = new BaseMetaColumn(table, value_column, value_column, "", false)

                let value_not = next("Not");
                let not = value_not != "0"
                if (value_not != "0" && value_not != "1")
                    ErrorOperation.throwHTTP(400, `Invalid value '${value_not}' for FilterItem.not, Only 0 and 1 are allowed.`);

                let value_operator = next("Operator");
                let operator = FilterItemOperator.getByName(value_operator);

                let values: string[] = [];
                for (let j = 0; j < operator.count; j++)
                {
                    let value_value = next("Value Number " + (j + 1));
                    let value = value_value.replace(/\\;/gm, ";");
                    values.push(value);
                }

                ans.push(new FilterItem(table, column, not, operator, ...values));
            }
        }
        return ans;
    }
    constructor(table: BaseMetaTable, column: BaseMetaColumn, not: boolean, operator: FilterItemOperator, ...values: string[])
    {
        this.table = table;
        this.column = column;
        this.not = not;
        this.operator = operator;
        this.values = values;
        if (this.values.length != operator.count)
            throw ErrorOperation.getHTTP(400, `Invalid count of values: ${this.values.length} is provided but ${operator.count} is required.`);
    }
    getCommand()
    {
        return [this.table.name, this.column.name, this.not ? "1" : "0", this.operator.name, ...this.values.map(x => (x ?? "").toString().replace(/;/gm, "\\;"))].join(";");
    }
    isAllColumns()
    {
        return this.column.name === "*";
    }
    toString()
    {
        let ans = [];
        if (!this.isAllColumns())
        {
            let table;
            let column;
            if (this.table.text)
                table = this.table.text;
            else
                table = this.table.name;
            if (this.column.text)
                column = this.column.text;
            else
                column = this.column.name;
            ans.push([table, column].filter(x => x).join("."));
        }
        if (this.not)
            ans.push("Not");
        if (!this.isAllColumns() || this.operator != FilterItemOperator.all.equals || this.not)
            ans.push(this.operator.name);
        ans.push(this.values.join(", "));
        return ans.filter(x => x).join(" ");
    }
}